import React, { useMemo } from 'react';

import ConnectorGroupView from './ConnectorGroup.view';
import { ConnectorType } from 'utils/enums/chargingType';

type Props = {
  type: ConnectorType;
  available: number;
  total: number;
  maxVoltage: number;
  address?: string;
};

const ConnectorGroup: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const connectorImg: string = useMemo(() => {
    return props.type === ConnectorType.IEC_62196_T1
      ? '/images/connectors/Plug-Icon-J1772.png'
      : props.type === ConnectorType.NEMA_5_20 || props.type === ConnectorType.NEMA_10_50
        ? '/images/connectors/Plug-Icon-Nema-515.png'
        : props.type === ConnectorType.NEMA_14_50
          ? '/images/connectors/Plug-Icon-Nema-1450.png`'
          : props.type === ConnectorType.NEMA_6_50
            ? '/images/connectors/Plug-Icon-Nema-1450.png' //TODO: NAME 650 IS MISSING
            : props.type === ConnectorType.TESLA
              ? '/images/connectors/Plug-Icon-Tesla.png'
              : props.type === ConnectorType.CHADEMO
                ? '/images/connectors/Plug-Icon-CHAdeMO.png'
                : '/images/connectors/Plug-Icon-J1772-Combo.png'; //TODO: needto check for default img
  }, [props.type]);

  const availableGroup: boolean = useMemo(() => {
    return props.available / (props.total || 1) < 1 ? true : false;
  }, [props.available, props.total]);

  return (
    <ConnectorGroupView
      address={props.address}
      type={props.type}
      connectorImg={connectorImg}
      available={props.available}
      total={props.available}
      maxVoltage={props.maxVoltage}
      availableGroup={availableGroup}
    >
      {props.children}
    </ConnectorGroupView>
  );
};

ConnectorGroup.displayName = 'ConnectorGroup';
ConnectorGroup.defaultProps = {};

export default ConnectorGroup;
